import { useEffect, useRef } from 'react';
export const audio_CA_Evening = "";//"https://ofofanam.myhostpoint.ch/tribschenstrasse/TS_ES_CA_Evening.mp3";
export const audio_CA_Morning = "https://ofofanam.myhostpoint.ch/tribschenstrasse/TS_ES_CA_Morning.mp3";
export const audio_CB_Evening = "https://ofofanam.myhostpoint.ch/tribschenstrasse/TS_ES_CB_Evening.mp3";
export const audio_CB_Morning = "https://ofofanam.myhostpoint.ch/tribschenstrasse/TS_ES_CB_Morning.mp3";
export const audio_CC_Evening = "https://ofofanam.myhostpoint.ch/tribschenstrasse/TS_ES_CC_Evening.mp3";
export const audio_CC_Morning = "https://ofofanam.myhostpoint.ch/tribschenstrasse/TS_ES_CC_Morning.mp3";

export const SKYBOX_AUDIO_FILES = [ audio_CA_Evening,audio_CA_Morning, audio_CB_Evening, audio_CB_Morning, audio_CC_Evening, audio_CC_Morning];
export const DEFAULT_SKYBOX_AUDIO_SRC = SKYBOX_AUDIO_FILES[0];
const globalAudioPlayer = new Audio();
globalAudioPlayer.loop = true;
globalAudioPlayer.crossOrigin = "anonymous"; // <-- Add this line
export function SkyboxEmbeddedAudioPlayer({ src, playAudio }) {
  const audioRef = useRef(null);

  useEffect(() => {
    // If there is no audio element or no source, do nothing
    if (!audioRef.current || !src) return;

    // Assign the video URL to the audio element
    const audioEl = audioRef.current;
    audioEl.src = src;
    audioEl.loop = true; // Ensure it loops with the skybox

    // If we are allowed to play, attempt to play
    if (playAudio) {
      audioEl.play().catch(error => {
        console.warn("Browser blocked audio autoplay. User must click somewhere first.", error);
      });
    } else {
      audioEl.pause();
    }

    // Cleanup function: pause when the component unmounts or URL changes
    return () => {
      audioEl.pause();
      audioEl.src = '';
    };
  }, [src, playAudio]); // Re-run whenever the video URL or play state changes

  // We return a hidden audio element. 
  // It exists in the DOM but is completely invisible.
  return (
    <audio ref={audioRef} style={{ display: 'none' }} />
  );
}
export function SkyboxAudioPlayer({ audioSrc = DEFAULT_SKYBOX_AUDIO_SRC, playAudio }) {
  console.debug("SkyboxAudioPlayer received new props. audioSrc:", audioSrc, "playAudio:", playAudio);
  useEffect(() => {
    // If there is no source, make sure the global player is silent
    if (!audioSrc) {
      console.debug("No audio source provided. Global audio player will be paused.");
      globalAudioPlayer.pause();
      return;
    }

    // 2. Brutally stop whatever the global player is currently doing
    globalAudioPlayer.pause();
    console.debug("paused global audio player to switch source. Previous src was:", globalAudioPlayer.src);

    globalAudioPlayer.removeAttribute('src');
    globalAudioPlayer.load();

    // 3. Assign the new source
    globalAudioPlayer.src = audioSrc;
    console.debug("Assigned new audio source:", globalAudioPlayer.src);

    // 4. Play if allowed
    if (playAudio) {
      console.debug("Attempting to play audio:", audioSrc);
      globalAudioPlayer.play().catch(error => {
        // Ignore AbortError (caused by clicking "Next" too fast)
        if (error.name !== 'AbortError') {
          console.warn("Autoplay blocked by browser:", error);
        }
      });
    } else {
      console.debug("Audio playback disabled.");
      globalAudioPlayer.pause();
    }

    // 5. Cleanup: Pause when the entire 3D scene unmounts
    return () => {
      globalAudioPlayer.pause();
      globalAudioPlayer.removeAttribute('src'); // Strip the source
      globalAudioPlayer.load();                 // Force memory clear
    };
  }, [audioSrc, playAudio]); // Only runs when the explicit URL or play state changes

  // 6. Return NOTHING. No HTML element is rendered to the DOM.
  return null; 
}